import { render, staticRenderFns } from "./SortingModal.vue?vue&type=template&id=35d4b12e&scoped=true&"
import script from "./SortingModal.vue?vue&type=script&lang=js&"
export * from "./SortingModal.vue?vue&type=script&lang=js&"
import style0 from "./SortingModal.vue?vue&type=style&index=0&id=35d4b12e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d4b12e",
  null
  
)

export default component.exports